import { render, staticRenderFns } from "./ProductProperties.vue?vue&type=template&id=e7275356"
import script from "./ProductProperties.vue?vue&type=script&lang=js"
export * from "./ProductProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports